import { render, staticRenderFns } from "./Configurator.vue?vue&type=template&id=583c3105&scoped=true"
import script from "./Configurator.vue?vue&type=script&lang=js"
export * from "./Configurator.vue?vue&type=script&lang=js"
import style0 from "./Configurator.vue?vue&type=style&index=0&id=583c3105&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c3105",
  null
  
)

export default component.exports